import { useEffect, useState } from 'react';
import { getPublicPage } from '../api/contentApi';
import { resolveMarketDetailContent } from '../utils/marketDetailFallback';

export const useMarketDetailContent = (slug, market) => {
  const [content, setContent] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      setIsLoading(true);

      try {
        const page = await getPublicPage(slug);
        if (!isMounted) {
          return;
        }

        setContent(resolveMarketDetailContent(page, market));
        setError(null);
      } catch (err) {
        if (!isMounted) {
          return;
        }

        setContent(market ? resolveMarketDetailContent(null, market) : null);
        setError(err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (slug && market) {
      load();
    } else {
      setContent(null);
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
    };
  }, [slug, market]);

  return { content, isLoading, error };
};
